import { render } from "./orderList.vue?vue&type=template&id=545e9408&scoped=true"
import script from "./orderList.vue?vue&type=script&lang=js"
export * from "./orderList.vue?vue&type=script&lang=js"

import "./orderList.vue?vue&type=style&index=0&id=545e9408&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545e9408"]])

export default __exports__